package lacaravana.ui

import kotlinx.browser.document
import kotlinx.coroutines.launch
import kotlinx.html.div
import kotlinx.html.dom.append
import kotlinx.html.h3
import kotlinx.html.js.onClickFunction
import kotlinx.html.span
import lacaravana.app.Database
import lacaravana.app.appScope
import lacaravana.domain.Mesa

object MesasView {
    suspend fun render(db: Database) {
        val content = document.getElementById("content") ?: return
        content.innerHTML = ""
        val mesas = Mesa.all(db)
        content.append {
            div("mesa-grid") {
                for (mesa in mesas) {
                    div("mesa mesa-${mesa.estado}") {
                        attributes["data-numero"] = mesa.numero.toString()
                        attributes["data-estado"] = mesa.estado
                        attributes["data-id"] = mesa.id.toString()
                        h3 { +"Mesa ${mesa.numero}" }
                        span { +mesa.estado }
                        onClickFunction = {
                            appScope.launch {
                                Mesa.toggleEstado(db, mesa.id)
                                render(db)
                            }
                        }
                    }
                }
            }
        }
    }
}
